export const CONFIG_AKM = {
  // AKM_HOST: "http://18.140.135.175:8015", // Server Production
  // AKM_HOST: "http://13.251.196.184:8015", // Server staging
  // AKM_HOST: "http://192.168.0.200:8015", // Server Localhost
  AKM_HOST: process.env.REACT_APP_API_ADMIN_REACT, // Server with .eviroment

  AKM_LIST: "/akm/list",
  CBT_PROFIL_POST: "/akm/tambah",
  GET_SUBPROFIL_BY_IDPROFIL: "/akm/getSubProfilByIdProfil/",
  GET_KATEGORI_AKM: "/akm/kategori",
  GET_JADWAL_BY_IDPROFIL: "/jadwalcbt/getByIdProfil?idProfil=",
  GET_JADWAL_MAPEL: "/akm/jadwalMapel/",
  POST_ADD_SUBPROFIL: "/akm/subProfil/add",
  GET_PROFIL_NON_AKADEMIK_AKM: "akm/nonAkademik/",
  POST_PROFIL_NON_AKADEMIK_AKM: "akm/nonAkademik/add",
  GET_PROFIL_NON_AKADEMIK_AGCU: "akm/nonAkademikAgcu/",
  GET_REPORT: "akm/report",
  GET_JUMLAH_SOAL_AKM: "akm/countSoalDetailAkmByMapel?idSubProfil=",

  KELAS_GROUP_ALL: "/kelas/group",
  KELAS_ALL: "/kelas",
  KURIKULUM_GET_ALL: "/kurikulum",
  MAPEL_GET_BY_IDKELASGROUP: "/mapel/findByIdKelasGroup/",
  MAPEL_GET_BY_IDKELAS: "/mapel/findByIdKelas/",
  IMPORT_MAPEL_SNMPTN: "/mapel/importSnmptn",
  GET_SEKOLAH_BY_ID: "sekolah/findById/",

  GET_TIPE_SOAL: "/soal/tipeSoal",
  GET_INDIKATOR: "/indikator",
  BANK_SOAL_LIST: "/soal/list",
  BANK_SOAL_POST: "/soal/add",
  POST_UPLOAD_HISTORY_ID: "soal/uploadHistory",
  POST_SOAL_DETAIL_AKM: "/soal/addSoalDetailAkm",
  GET_SOAL_DETAIL_AKM_BY_IDBANKSOAL: "/soal/findSoalDetailAkmByIdBankSoal?idBankSoal=",
  GET_JUMLAH_SOAL_AKM_BY_IDBANKSOAL: "/soal/countSoalDetailAkm?idBankSoal=",

  GET_ROLE: "/menus/getRoles",
  GET_USER_BY_ROLE: "/menus/userByRole?idRole=",
  GET_MENUS_BY_ROLE: "/menus/getMenuRole?idRole=",
  POST_ADD_SYS_MENU: "/menus/add/",

  // SEKOLAH
  ADD_SEKOLAH: "/sekolah/add/",
  IMPORT_SEKOLAH: "/sekolah/import/",
  FETCH_SEKOLAH_BY_ID_KAB_AND_JENJANG: "/sekolah/findSekolahByIdKabJenjang",
  FETCH_SEKOLAH_BY_ID_KAB: "/sekolah/findByIdKabupaten/",
  GET_KODE_JENJANG: "/sekolah/getKodeJenjang",

  // SNMPTN
  SEKOLAH_SMA_SEDERAJAT: "/snmptn/sekolah/",
  SEKOLAH_SEARCH_BY_LIKE: "/snmptn/sekolahlikename/",
  AKTFKAN_NONAKTIFKAN_SNMPTN: "/snmptn/onoffsnmptnsekolah/",

  // REPORT
  FETCH_JADWAL_CBT: "/jadwalcbt/getJadwalAkm/",
  GET_SEKOLAH_BY_ID_KELAS_KABUPATENKOTA: "/sekolah/findSekolahByKabupatenAndKelas/",

  // KELAS
  GET_KELAS_BY_ID_SEKOLAH: "/kelas/byIdSekolah/",
  GET_KELAS_BY_KODE_JENJANG: "/kelas/byKodeJenjang/",

  // KELAS PARALEL
  FETCH_KELAS_PARALEL_BY_ID_SEKOLAH_KELAS: "/kelasparalel/byIdSekolahAndIdKelas/",
  ADD_KELAS_PARALEL: "/kelasparalel/add/",

  // SISWA
  FETCH_SISWA_BY_ID_KELAS_PARALEL_AND_SEKOLAH: "siswa/byIdKelasParalelAndIdSekolah/",
  IMPORT_SISWA: "siswa/import/",
  DELETE_SISWA_EXCEL: "siswa/hapusviaexcell",
  SEARCH_DETAIL_SISWA: "siswa/",
  MANAGE_ACCOUNT_SCHOOL: "admin/sekolah/",
  MANAGE_ACCOUNT_SCHOOL: "admin/sekolah/",

  //SBMPTN
  IMPORT_PRODI_SBMPTN: "prodi/import?typeUpload=",
  SUBPROFIL_SOAL_SBMPTN: "subProfil/fetchSoal?idSubProfilCbt=",
  SET_POIN_SBMPTN: "cbtSoalHub/setPoint",

  //PTN
  ADD_PTN: "ptn/add",

  // PAKET PROGTAM
  SIMPAN_PAKET_PROGRAM: "paketprogram/",
  FETCH_PAKET_PROGRAM_AKTIF: "paketprogram/",
  FETCH_PAKET_PROGRAM_AKTIF_LIST: "paketprogram/list",
  FETCH_PAKET_PROGRAM_ALL: "paketprogram/all",

  // PENJUALAN VOUCHER
  FETCH_PENJUALAN_LIST: "penjualanvoucher/list?",
  FETCH_PENJUALAN_VOUCHER_BY_ID_PAKET: "penjualanvoucher/penjualanByPaketProgram/",
  SIMPAN_PENJUALAN_VOUCHER: "penjualanvoucher/add",
  UPDATE_PENJUALAN_VOUCHER: "penjualanvoucher/update/",
  HITUNG_PENJUALAN_VOUCHER_BY_PP: "penjualanvoucher/hitungPenjualanByPaketProgram/", // idPaketProgram

  // VOUCHER
  FETCH_VOUCHER_BY_ID_PENJUALAN: "voucher/bypenjualan/",
  FETCH_VOUCHER_BY_ID_PENJUALAN_ID_SEKOLAH: "voucher/voucherSekolah/",
  SIMPAN_VOUCHER_SEKOLAH: "voucher/simpanVoucherSekolah/",
  FETCH_STOK_VOUCHER_BY_KODE_TIPE: "voucher/stokVoucher/",
  FETCH_STUDENT_BY_USERNAME: "siswa/byUsername/",
  FETCH_STUDENT_BY_SCHOOL: "siswa/sekolah/",
  ACTIVATE_VOUCHER: "voucher/activateVoucher",

  // PROFIL
  PROFIL_AGCU_NON: "profil/agcunon",
  PROFIL_LIST: "profil/list",
  PROFIL_DUBLICATE: "profil/dublicate",

  GET_KATEGORI_SUB_PROFIL: "kategorisubprofil",

  // JADWAL
  FETCH_PAKET_PROGRAM_HUB: "jadwalprogramhub/list",
  FETCH_JADWAL_AND_PROFIL_BY_PAKET_PROGRAM: "jadwalcbt/getByIdPaketProgram?idPaketProgram=",
  SAVE_DELETE_PAKET_PROGRAM_HUB: "jadwalprogramhub/",

  //admin
  GET_ADMIN_ROLE_ALL: "admin/adminRole",
  GET_ADMIN_ROLE_BY_ID: "admin/adminByRole",
  POST_SAVE_ADMIN: "/admin/add",
  DELETE_ADMIN: "/admin/delete/",
  // GET_ALL_ACCOUNT_SCHOOL: "/admin/sekolah/",
  GET_ALL_ACCOUNT_STUDENT: "/siswa/all",
  // GET_ALL_ACCOUNT_SCHOOL: "/admin/sekolah/",
  GET_ALL_ACCOUNT_STUDENT: "/siswa/all",

  //Kabupaten
  GET_KABUPATEN_BY_ID: "kabKota/getById",

  //dinas
  POST_DINAS_PEMDA_SAVE: "/dinas/dinasPemda/add",
  POST_DINAS_DETAIL_SAVE: "/dinas/dinasDetails/add",
  DINAS_PEMDA_GET_BY_ID: "/dinas/getById",
  DINAS_DETAIL_GET_BY_ID_DINAS: "/dinas/dinasDetails",
  DINAS_GET_BY_LIKE_NAME: "/dinas/getByName?namaDinas=",

  // List Prodi
  LIST_PRODI_UNIK: "nama-prodi-unik-ptn",
  LIST_PRODI: "prodi/list",
  UPLDATE_LIST_PRODI_SNMPTN: "prodi/updateSnmptn",
  UPLDATE_LIST_PRODI_SBMPTN: "prodi/updateSbmptn",

  SUCCESS_ERROR_CODE: "EP-000",
};
